import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ABUtils } from '../../utils';
import { Div } from '../../layouts';

export const NumberPicker = ({
    min,
    max,
    value,
    onChange,
    step,
}) => {
    const { isCssVariation } = ABUtils.getABs();

    const decClick = () => {
        const newValue = value - step;
        if (newValue >= min) {
            onChange(newValue);
        }
    };
    const incClick = () => {
        const newValue = value + step;
        if (newValue <= max) {
            onChange(newValue);
        }
    };

    const classNameDec = classNames({
        'odf-btn odf-btn-secondary odf-btn-square dec odf-btn-square-sm': !isCssVariation,
        'prisma-btn prisma-btn-default prisma-btn-icon-only prisma-btn-sm prisma-btn-circle odf-space-outer-right-s': isCssVariation,
        'prisma-btn-disabled': value === min && isCssVariation,
        'disabled': value === min && !isCssVariation,
    });
    const classNameInc = classNames({
        'odf-btn odf-btn-secondary odf-btn-square inc odf-btn-square-sm': !isCssVariation,
        'prisma-btn prisma-btn-default prisma-btn-icon-only prisma-btn-sm prisma-btn-circle odf-space-outer-left-s': isCssVariation,
        'prisma-btn-disabled': value === max && isCssVariation,
        'disabled': value === max && !isCssVariation,
    });
    const classNameIconDec = classNames({
        'odf-icon odf-icon-less': true,
        'odf-icon-xl': isCssVariation,
    });
    const classNameIconInc = classNames({
        'odf-icon odf-icon-plus': true,
        'odf-icon-xl': isCssVariation,
    });

    return (
        <div className="odf-row-inline odf-row-nogutter">
            <div className="odf-col">
                <button
                    type="button"
                    data-testid="decrease-picker"
                    className={classNameDec}
                    onClick={decClick}
                >
                    <span className={classNameIconDec} />
                </button>
            </div>
            <Div className="odf-col" width="26px">
                <div className="odf-space-inner-left-s odf-space-inner-right-s">{value}</div>
            </Div>
            <div className="odf-col">
                <button
                    type="button"
                    data-testid="increase-picker"
                    className={classNameInc}
                    onClick={incClick}
                >
                    <span className={classNameIconInc} />
                </button>
            </div>
        </div>
    );
};

NumberPicker.propTypes = {
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    step: PropTypes.number,
};

NumberPicker.defaultProps = {
    step: 1,
};
